// src/components/admin/Gallery.jsx
import React, { useEffect, useState, useRef } from 'react';
import { Plus, Trash2, ImageIcon, X, Edit2, Save } from 'lucide-react';
import api from "../../../services/httpService";
import './Gallery.css';

const Gallery = () => {
  // Hero Section State
  const [heroSection, setHeroSection] = useState(null);
  const [heroImageKeys, setHeroImageKeys] = useState([]);
  const [heroImageFile, setHeroImageFile] = useState(null);
  const [heroImagePreview, setHeroImagePreview] = useState('');
  const [isEditingHero, setIsEditingHero] = useState(false);
  const [isHeroLoading, setIsHeroLoading] = useState(false);
  const [isHeroSaving, setIsHeroSaving] = useState(false);
  const [heroMessage, setHeroMessage] = useState('');
  const [heroTitle, setHeroTitle] = useState('');
  const [heroDescription, setHeroDescription] = useState('');
  
  // Gallery State
  const [galleryItems, setGalleryItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState('');

  // Add Form State
  const [newImages, setNewImages] = useState([]);
  const [newImagePreviews, setNewImagePreviews] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  // Refs
  const heroFileInputRef = useRef(null);
  const galleryFileInputRef = useRef(null);

  const AWS_IMAGE_URL = process.env.REACT_APP_AWS_IMAGE_URL || '';

  useEffect(() => {
    fetchHeroSection();
    fetchGallery();
  }, []);

  // Helper to construct image URL
  const constructImageUrl = (key) => {
    if (!key) return '';
    // If it's already a full URL, return as is
    if (key.startsWith('http')) return key;
    const cleanKey = key.replace(/^\/+/, '');
    const baseUrl = AWS_IMAGE_URL.replace(/\/+$/, '');
    return `${baseUrl}/${cleanKey}`;
  };

  // ==================== HERO SECTION FUNCTIONS ====================
//   const fetchHeroSection = async () => {
//     setIsHeroLoading(true);
//     try {
//       // Get all galleries
//       const res = await api.get('/sentinix/galleries');
//       console.log('All Galleries:', res.data);
      
//       if (res.data.success) {
//         const allData = res.data.data || [];
        
//         // Find hero section (type === 'hero')
//         const heroData = allData.find(item => item.type === 'hero' && !item.isDeleted);
        
//         if (heroData) {
//           const heroItem = {
//             id: heroData.id || heroData._id,
//             type: heroData.type || 'hero',
//             imageKeys: heroData.imageKeys || [],
//             title: heroData.title || '',
//             description: heroData.description || '',
//             createdAt: heroData.createdAt,
//             updatedAt: heroData.updatedAt
//           };
          
//           setHeroSection(heroItem);
//           setHeroImageKeys(heroItem.imageKeys);
//           setHeroTitle(heroData.title || '');
//           setHeroDescription(heroData.description || '');
//         } else {
//           setHeroSection(null);
//           setHeroImageKeys([]);
//           setHeroTitle('');
//           setHeroDescription('');
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching hero section:', error);
//       setHeroSection(null);
//       setHeroImageKeys([]);
//       setHeroTitle('');
//       setHeroDescription('');
//     } finally {
//       setIsHeroLoading(false);
//     }
//   };
const fetchHeroSection = async () => {
  setIsHeroLoading(true);
  try {
    // Get all galleries
    const res = await api.get('/sentinix/galleries');
    console.log('All Galleries:', res.data);
    
    if (res.data.success) {
      const allData = res.data.data || [];
      
      // Find hero section (type === 'hero')
      const heroData = allData.find(item => item.type === 'hero' && !item.isDeleted);
      
      if (heroData) {
        console.log('Found hero data:', heroData);
        
        const heroItem = {
          id: heroData.id || heroData._id,
          type: heroData.type || 'hero',
          imageKeys: heroData.imageKeys || [],
          title: heroData.title || '',
          description: heroData.description || '',
          createdAt: heroData.createdAt,
          updatedAt: heroData.updatedAt
        };
        
        setHeroSection(heroItem);
        setHeroImageKeys(heroItem.imageKeys);
        setHeroTitle(heroData.title || '');
        setHeroDescription(heroData.description || '');
        
        // Clear any temporary states
        setHeroImageFile(null);
        setHeroImagePreview('');
      } else {
        setHeroSection(null);
        setHeroImageKeys([]);
        setHeroTitle('');
        setHeroDescription('');
      }
    }
  } catch (error) {
    console.error('Error fetching hero section:', error);
    setHeroSection(null);
    setHeroImageKeys([]);
    setHeroTitle('');
    setHeroDescription('');
  } finally {
    setIsHeroLoading(false);
  }
};

  const handleHeroImageSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      setHeroMessage('Please select an image file');
      setTimeout(() => setHeroMessage(''), 3000);
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      setHeroMessage('File size should be less than 5MB');
      setTimeout(() => setHeroMessage(''), 3000);
      return;
    }

    setHeroImageFile(file);

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setHeroImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

//   const handleSaveHero = async () => {
//     if (!heroImageFile && heroImageKeys.length === 0) {
//       setHeroMessage('Hero image is required');
//       setTimeout(() => setHeroMessage(''), 3000);
//       return;
//     }

//     if (!heroTitle.trim()) {
//       setHeroMessage('Title is required for hero section');
//       setTimeout(() => setHeroMessage(''), 3000);
//       return;
//     }

//     if (!heroDescription.trim()) {
//       setHeroMessage('Description is required for hero section');
//       setTimeout(() => setHeroMessage(''), 3000);
//       return;
//     }

//     setIsHeroSaving(true);
//     setHeroMessage('');

//     try {
//       const formData = new FormData();
//       formData.append('type', 'hero');
//       formData.append('title', heroTitle.trim());
//       formData.append('description', heroDescription.trim());

//       // Append image file with correct field name
//       if (heroImageFile) {
//         formData.append('imageKeys', heroImageFile);
//         console.log('Appending image file:', heroImageFile.name);
//       }

//       let res;
//       if (heroSection?.id) {
//         console.log('Updating hero section with ID:', heroSection.id);
//         res = await api.put(`/sentinix/galleries/${heroSection.id}`, formData, {
//           headers: { 'Content-Type': 'multipart/form-data' }
//         });
//       } else {
//         console.log('Creating new hero section');
//         res = await api.post('/sentinix/galleries', formData, {
//           headers: { 'Content-Type': 'multipart/form-data' }
//         });
//       }

//       console.log('Save response:', res.data);

//       if (res.data.success) {
//         setHeroMessage('Hero section saved successfully!');
//         setIsEditingHero(false);
//         setHeroImageFile(null);
//         setHeroImagePreview('');
//         fetchHeroSection(); // Refresh data
//       } else {
//         setHeroMessage(res.data.message || 'Failed to save hero section');
//       }
//     } catch (error) {
//       console.error('Error saving hero section:', error);
//       setHeroMessage(error.response?.data?.message || 'Error saving hero section');
//     } finally {
//       setIsHeroSaving(false);
//       setTimeout(() => setHeroMessage(''), 3000);
//     }
//   };

const handleSaveHero = async () => {
  // First check title and description
  if (!heroTitle.trim()) {
    setHeroMessage('Title is required for hero section');
    setTimeout(() => setHeroMessage(''), 3000);
    return;
  }

  if (!heroDescription.trim()) {
    setHeroMessage('Description is required for hero section');
    setTimeout(() => setHeroMessage(''), 3000);
    return;
  }

  // Then check image
  if (!heroImageFile && heroImageKeys.length === 0) {
    setHeroMessage('Hero image is required');
    setTimeout(() => setHeroMessage(''), 3000);
    return;
  }

  setIsHeroSaving(true);
  setHeroMessage('');

  try {
    const formData = new FormData();
    formData.append('type', 'hero');
    formData.append('title', heroTitle.trim());
    formData.append('description', heroDescription.trim());

    // Append image file with correct field name
    if (heroImageFile) {
      formData.append('imageKeys', heroImageFile);
      console.log('Appending image file:', heroImageFile.name);
    }

    let res;
    if (heroSection?.id) {
      console.log('Updating hero section with ID:', heroSection.id);
      res = await api.put(`/sentinix/galleries/${heroSection.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    } else {
      console.log('Creating new hero section');
      res = await api.post('/sentinix/galleries', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }

    console.log('Save response:', res.data);

    if (res.data.success) {
      setHeroMessage('Hero section saved successfully!');
      setIsEditingHero(false);
      
      // Clear file states
      setHeroImageFile(null);
      setHeroImagePreview('');
      
      // Wait a moment then refresh data
      setTimeout(() => {
        fetchHeroSection(); // Refresh data
      }, 500);
    } else {
      setHeroMessage(res.data.message || 'Failed to save hero section');
    }
  } catch (error) {
    console.error('Error saving hero section:', error);
    setHeroMessage(error.response?.data?.message || 'Error saving hero section');
  } finally {
    setIsHeroSaving(false);
    setTimeout(() => setHeroMessage(''), 3000);
  }
};

  // ==================== GALLERY FUNCTIONS ====================
  const fetchGallery = async () => {
    setIsLoading(true);
    try {
      // Get all galleries
      const res = await api.get('/sentinix/galleries');
      console.log('Gallery Response:', res.data);
      
      if (res.data.success) {
        const allData = res.data.data || [];
        
        // Filter only gallery type items
        const galleries = allData
          .filter(item => item.type === 'gallery' && !item.isDeleted)
          .map(item => ({
            id: item.id || item._id,
            type: item.type,
            imageKeys: item.imageKeys || [],
            title: item.title || '',
            description: item.description || '',
            createdAt: item.createdAt,
            updatedAt: item.updatedAt
          }));
        
        console.log('Filtered Gallery Items:', galleries);
        setGalleryItems(galleries);
      }
    } catch (error) {
      console.error('Error fetching gallery:', error);
      setMessage('Error loading gallery items');
      setTimeout(() => setMessage(''), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGalleryImagesSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    // Validate total files count
    if (newImages.length + files.length > 10) {
      setMessage(`Maximum 10 images allowed. You can add ${10 - newImages.length} more.`);
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    // Validate each file
    const validFiles = files.filter(file => {
      if (!file.type.startsWith('image/')) {
        setMessage(`${file.name} is not an image file`);
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        setMessage(`${file.name} is larger than 5MB`);
        return false;
      }
      return true;
    });

    if (validFiles.length === 0) return;

    // Add files to state
    setNewImages(prev => [...prev, ...validFiles]);

    // Create previews
    validFiles.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewImagePreviews(prev => [...prev, reader.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  const removeImageFromSelection = (index) => {
    setNewImages(prev => prev.filter((_, i) => i !== index));
    setNewImagePreviews(prev => prev.filter((_, i) => i !== index));
  };

  const resetAddForm = () => {
    setNewImages([]);
    setNewImagePreviews([]);
    if (galleryFileInputRef.current) {
      galleryFileInputRef.current.value = '';
    }
  };

  const handleAddGalleryItem = async () => {
    if (newImages.length === 0) {
      setMessage('Please select at least one image');
      setTimeout(() => setMessage(''), 3000);
      return;
    }

    setIsSaving(true);
    setMessage('');

    try {
      // Create multiple gallery items - one per image
      for (const file of newImages) {
        const formData = new FormData();
        formData.append('type', 'gallery');
        formData.append('imageKeys', file);
        formData.append('title', ''); // Optional title
        formData.append('description', ''); // Optional description

        console.log('Adding gallery image:', file.name);
        const res = await api.post('/sentinix/galleries', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        
        if (!res.data.success) {
          throw new Error(res.data.message || 'Failed to add image');
        }
      }
      
      setMessage(`Successfully added ${newImages.length} image(s)!`);
      resetAddForm();
      fetchGallery(); // Refresh the gallery
      
    } catch (error) {
      console.error('Error adding gallery items:', error);
      setMessage(error.response?.data?.message || 'Error adding images');
    } finally {
      setIsSaving(false);
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const handleDeleteGalleryItem = async (id) => {
    if (!window.confirm('Are you sure you want to delete this image from gallery?')) {
      return;
    }

    try {
      const res = await api.delete(`/sentinix/galleries/${id}`);
      
      if (res.data.success) {
        setMessage('Image deleted successfully from gallery');
        fetchGallery();
      } else {
        setMessage(res.data?.message || 'Failed to delete image');
      }
    } catch (error) {
      console.error('Error deleting gallery item:', error);
      setMessage(error.response?.data?.message || 'Error deleting image from gallery');
    } finally {
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const totalImages = galleryItems.reduce((acc, item) => {
    return acc + (item.imageKeys?.length || 0);
  }, 0);

  return (
    <div className="gallery-container">
      <div className="gallery-wrapper">
        {/* Page Header */}
        <div className="gallery-header">
          <h1 className="gallery-title">Gallery Management</h1>
        </div>

        {/* ==================== GALLERY HERO SECTION ==================== */}
        <div className="hero-section-card">
          <div className="hero-section-header">
            <div>
              <h2 className="hero-section-title">Gallery Hero Section</h2>
            </div>
            <button
              onClick={() => setIsEditingHero(!isEditingHero)}
              className={`hero-edit-btn ${isEditingHero ? 'cancel' : ''}`}
            >
              {isEditingHero ? (
                <>
                  <X className="icon-sm" />
                  Cancel
                </>
              ) : (
                <>
                  <Edit2 className="icon-sm" />
                  {heroSection ? 'Edit Hero' : 'Create Hero'}
                </>
              )}
            </button>
          </div>

          {isHeroLoading ? (
            <div className="loading-spinner">
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="hero-content">
              {/* Show current hero info when not editing */}
             {heroSection && !isEditingHero && (
  <div className="hero-info">
    <div className="info-item">
      <p className="info-label">Title</p>
      <p className="info-value">{heroSection.title}</p>
    </div>
    <div className="info-item">
      <p className="info-label">Description</p>
      <p className="info-description">{heroSection.description}</p>
    </div>
    {heroSection.imageKeys && heroSection.imageKeys.length > 0 && (
      <div className="info-item">
        <p className="info-label">Hero Image</p>
        <div className="hero-image-preview">
          <img
            key={heroSection.imageKeys[0]} // Add key to force re-render
            src={constructImageUrl(heroSection.imageKeys[0])}
            alt="Gallery hero banner"
            className="hero-image"
            onError={(e) => {
              console.log('Image failed to load:', heroSection.imageKeys[0]);
              e.target.src = '/placeholder-image.png';
            }}
            onLoad={() => console.log('Image loaded successfully')}
          />
        </div>
      </div>
    )}
  </div>
)}

              {/* Edit/Create Form */}
              {(isEditingHero || !heroSection) && (
                <>
                  <div className="form-group">
                    <label className="form-label">
                      Title <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      value={heroTitle}
                      onChange={(e) => setHeroTitle(e.target.value)}
                      placeholder="Enter hero section title"
                      className="form-input"
                    />
                  </div> 
                  
                  <div className="form-group">
                    <label className="form-label">
                      Description <span className="required">*</span>
                    </label>
                    <textarea
                      value={heroDescription}
                      onChange={(e) => setHeroDescription(e.target.value)}
                      placeholder="Enter hero section description"
                      className="form-textarea"
                      rows={4}
                    />
                  </div>

                  {/* Hero Image Upload */}
                  <div className="form-group">
                    <label className="form-label">
                      Hero Image <span className="required">*</span>
                    </label>
                    
                    {/* Preview */}
                    {(heroImagePreview || heroImageKeys.length > 0) && (
                      <div className="hero-image-preview">
                        <img
                          src={heroImagePreview || constructImageUrl(heroImageKeys[0])}
                          alt="Hero Preview"
                          className="hero-image"
                          onError={(e) => {
                            e.target.src = '/placeholder-image.png';
                          }}
                        />
                      </div>
                    )}

                    {/* File Input */}
                    <div className="file-input-wrapper">
                      <input
                        type="file"
                        ref={heroFileInputRef}
                        accept="image/*"
                        onChange={handleHeroImageSelect}
                        className="file-input"
                      />
                      <button
                        type="button"
                        onClick={() => heroFileInputRef.current?.click()}
                        className="file-input-btn"
                      >
                        Choose Image
                      </button>
                      {heroImageFile && (
                        <span className="file-name">{heroImageFile.name}</span>
                      )}
                      {!heroImageFile && heroImageKeys.length > 0 && (
                        <span className="file-name">Current image will be kept</span>
                      )}
                    </div>
                  </div>

                  {/* Save Button */}
                  <div className="form-actions">
                    <button
                      onClick={handleSaveHero}
                      disabled={isHeroSaving || (!heroImageFile && heroImageKeys.length === 0) || !heroTitle.trim() || !heroDescription.trim()}
                      className={`save-btn ${(isHeroSaving || (!heroImageFile && heroImageKeys.length === 0) || !heroTitle.trim() || !heroDescription.trim()) ? 'disabled' : ''}`}
                    >
                      {isHeroSaving ? (
                        <>
                          <div className="spinner-small"></div>
                          Saving...
                        </>
                      ) : (
                        <>
                          <Save className="icon-sm" />
                          {heroSection ? 'Update Hero Section' : 'Create Hero Section'}
                        </>
                      )}
                    </button>
                    <button
                      onClick={() => {
                        setIsEditingHero(false);
                        if (heroSection) {
                          setHeroTitle(heroSection.title);
                          setHeroDescription(heroSection.description);
                          setHeroImageKeys(heroSection.imageKeys || []);
                        }
                        setHeroImageFile(null);
                        setHeroImagePreview('');
                      }}
                      className="cancel-btn"
                    >
                      Cancel
                    </button>
                    {heroMessage && (
                      <span
                        className={`message ${
                          heroMessage.includes('success') || heroMessage.includes('successfully')
                            ? 'success'
                            : 'error'
                        }`}
                      >
                        {heroMessage}
                      </span>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {/* ==================== GALLERY ITEMS SECTION ==================== */}
        {/* Message Alert */}
        {message && (
          <div className={`alert-message ${message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}

        {/* Main Content Grid */}
        <div className="gallery-grid">
          {/* Left Column - Add Form */}
          <div className="add-form-column">
            <div className="add-form-card">
              <div className="add-form-header">
                <div>
                  <h3 className="add-form-title">
                    <Plus className="icon-md" />
                    Add Gallery Images
                  </h3>
                </div>
                {newImages.length > 0 && (
                  <button
                    onClick={resetAddForm}
                    className="clear-btn"
                    title="Clear all images"
                  >
                    <X className="icon-sm" />
                  </button>
                )}
              </div>

              <div className="add-form-body">
                {/* Selected Images Preview */}
                {newImagePreviews.length > 0 && (
                  <div className="preview-section">
                    <label className="preview-label">
                      Selected Images ({newImages.length}/10)
                    </label>
                    <div className="preview-grid">
                      {newImagePreviews.map((preview, index) => (
                        <div key={index} className="preview-item">
                          <div className="preview-image-container">
                            <img
                              src={preview}
                              alt={`Selected ${index + 1}`}
                              className="preview-image"
                            />
                            <button
                              onClick={() => removeImageFromSelection(index)}
                              className="remove-btn"
                            >
                              <X className="icon-xs" />
                            </button>
                          </div>
                          <div className="preview-index">
                            {index + 1}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* File Upload */}
                <div className="upload-section">
                  <label className="upload-label">
                    Select Images
                  </label>
                  <div className="file-input-wrapper">
                    <input
                      type="file"
                      ref={galleryFileInputRef}
                      accept="image/*"
                      multiple
                      onChange={handleGalleryImagesSelect}
                      className="file-input"
                    />
                    <button
                      type="button"
                      onClick={() => galleryFileInputRef.current?.click()}
                      className="file-input-btn large"
                    >
                      <Plus className="icon-sm" />
                      Choose Images
                    </button>
                    {newImages.length > 0 && (
                      <p className="file-count">{newImages.length} image(s) selected</p>
                    )}
                  </div>
                  <p className="upload-hint">
                    You can select up to 10 images (max 5MB each)
                  </p>
                </div>

                {/* Add Button */}
                <div className="add-button-container">
                  <button
                    onClick={handleAddGalleryItem}
                    disabled={newImages.length === 0 || isSaving}
                    className={`add-btn ${newImages.length === 0 || isSaving ? 'disabled' : ''}`}
                  >
                    {isSaving ? (
                      <>
                        <div className="spinner-small"></div>
                        Adding...
                      </>
                    ) : (
                      <>
                        <Plus className="icon-sm" />
                        Add {newImages.length} Image{newImages.length !== 1 ? 's' : ''}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Gallery Grid */}
          <div className="gallery-column">
            <div className="gallery-card">
              {/* Gallery Header */}
              <div className="gallery-card-header">
                <div className="gallery-header-content">
                  <h3 className="gallery-card-title">Gallery Images</h3>
                  <p className="gallery-stats">
                    Total: {totalImages} image{totalImages !== 1 ? 's' : ''}
                  </p>
                </div>
                <button
                  onClick={() => fetchGallery()}
                  className="refresh-btn"
                >
                  Refresh
                </button>
              </div>

              {/* Gallery Content */}
              <div className="gallery-card-body">
                {isLoading ? (
                  <div className="loading-state">
                    <div className="spinner"></div>
                    <p className="loading-text">Loading gallery images...</p>
                  </div>
                ) : galleryItems.length === 0 ? (
                  <div className="empty-state">
                    <ImageIcon className="empty-icon" />
                    <h3 className="empty-title">No Images Found</h3>
                  </div>
                ) : (
                  <div className="images-grid">
                    {galleryItems.map((gallery) => {
                      const imageKey = gallery.imageKeys?.[0];
                      
                      return (
                        <div 
                          key={gallery.id}
                          className="image-card"
                        >
                          <div className="image-wrapper">
                            {imageKey ? (
                              <img
                                src={constructImageUrl(imageKey)}
                                alt="Gallery item"
                                className="gallery-image"
                                onError={(e) => {
                                  e.target.src = '/placeholder-image.png';
                                }}
                              />
                            ) : (
                              <div className="image-placeholder">
                                <ImageIcon className="icon-xl" />
                              </div>
                            )}
                            
                            {/* Delete Button */}
                            <div className="delete-btn-container">
                              <button
                                onClick={() => handleDeleteGalleryItem(gallery.id)}
                                className="delete-btn"
                                title="Delete image"
                              >
                                <Trash2 className="icon-sm" />
                              </button>
                            </div>
                          </div>

                          {/* Gallery Info */}
                          <div className="image-info">
                            <div className="image-date">
                              Added: {new Date(gallery.createdAt).toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;